import FAQComponent from "@/components/FAQ";
import SEO from "@/components/SEO";

const FAQ = () => {
  return (
    <div className="min-h-screen relative overflow-hidden">
      <SEO 
        title="FAQ - Frequently Asked Questions | Oraculus:X Crypto Trading Signals Help"
        description="Find answers about Oraculus:X crypto signals: pricing, free trials, risk management, refund policy, trading features, and platform support. Get help fast."
      />
      <div className="fixed inset-0 bg-gradient-mesh animate-mesh-move opacity-40" />
      <div className="fixed inset-0 bg-gradient-opal-radial animate-gradient-shift" style={{ backgroundSize: '200% 200%' }} />
      
      <main className="relative z-10 pt-20 md:pt-32">
        <FAQComponent />
      </main>
    </div>
  );
};

export default FAQ;
